import Point from './Point';
import IBoundingBox from './IBoundingBox';
import MathUtils from './MathUtils';

export default class Circle implements IBoundingBox {
	readonly position:Point;
	readonly radius:number;

	constructor(x:number, y:number, radius:number){
		this.position = new Point(x, y);
		this.radius = radius;
	}

	public hit = (target:Point):boolean => {
		return MathUtils.distance(this.position, target) < this.radius;
	}
}